import { createExportToCsvFactory } from "./createExportToCsv";
export const handleExportChangelogTableFactory = (options) => {
    const { columns, dataSource, handleExportError, csvOptions = {}, defaultCsvOptions = {}, } = options;
    const createExportToCsv = createExportToCsvFactory({
        defaultCsvOptions,
    });
    const csvExporter = createExportToCsv(csvOptions);
    const handleExportChangelogTable = () => {
        try {
            const columnFields = {};
            columns.forEach((column) => {
                columnFields[column.field] = column.caption;
            });
            const data = dataSource.items().map((item) => {
                var _a;
                const newItem = {};
                (_a = Object.keys(columnFields !== null && columnFields !== void 0 ? columnFields : {})) === null || _a === void 0 ? void 0 : _a.forEach((field) => {
                    newItem[columnFields[field]] = typeof item[field] === 'object'
                        ? JSON.stringify(item[field])
                        : item[field];
                });
                return newItem;
            });
            csvExporter.generateCsv(data);
        }
        catch (e) {
            if (handleExportError) {
                handleExportError(e);
            }
        }
    };
    return handleExportChangelogTable;
};
//# sourceMappingURL=handleExportChangelogTable.js.map